/*
  INSERT INTO _41rs (_dmn, _key, _fst, _icn, _pfx, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 1, 1, '1', 'エントリー・抽選・直接予約', -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  UPDATE _41rs SET _vsn=1, _ltt=1;

  INSERT INTO _411s (_dmn, _key, _fst, _411_41r1k, _411_40r1k, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 1, 1, 1, 2030, -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _411s (_dmn, _key, _fst, _411_41r1k, _411_40r1k, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 2, 2, 1, 2040, -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  INSERT INTO _411s (_dmn, _key, _fst, _411_41r1k, _411_40r1k, _who, _dtm, "createdAt", "updatedAt")
  VALUES (1, 3, 3, 1, 2050, -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00');
  UPDATE _411s SET _vsn=1, _ltt=1;

*/

export const _41z = {
  _41r: { // 役割情報
    v0: {
      itlz: {
        _41r_31r1f: -1, 
      },
      fldz: {
        _41r_31r1f: { // 所属組織 
        },
      },
    },
  },
  _411: { // 役割別機能情報
    v0: {
      itlz: {
        _411_31r1f: -1,
        _411_41r1k: -1,
        _411_40r1k: -1, // 機能は version を持たない
      },
      fldz: {
        _411_31r1f: { // 所属組織 
        },
        _411_41r1k: { // 役割情報
        },
        _411_40r1k: { // 機能情報
        },
      },
    },
  },
};
